import "./Header.scss";

import { Link, useLocation } from "react-router-dom";
import { FCC } from "types";

import Logo from "@/assets/header/Logo.svg?react";

export const Header: FCC = ({ children }) => {
  const location = useLocation();
  const isPartnerRoute = location.pathname.startsWith("/partner");
  const homeLink = isPartnerRoute ? "/partner/cockpit" : "/portal/cockpit";

  return (
    <header id="header-container" data-testid="header">
      <div className="wave" />
      <Link to={homeLink}>
        <Logo className="logo" />
      </Link>
      {children}
    </header>
  );
};
